import axios from "../../axios";

const getMessages = async (customer_id, resource, resource_id) => {
  let filters = ``;
  if (customer_id) {
    filters = `?customer_id[$eq]=${customer_id}`;
  }
  if (resource) {
    filters += `&resource[$eq]=${resource}`;
  }
  if (resource_id) {
    filters += `&resource_id[$eq]=${resource_id}`;
  }
  if (filters.charAt(0) === '&') {
    filters = filters.replace('&', '?');
  }
  try {
    const { data } = await axios.get(`/messages${filters}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const sendMessage = async ({text, resource, resource_id, customer_id, trigger = 'manual', message_type = 'conversation'}) => {
  console.log(text, resource, resource_id, customer_id, "text!!!!");
  try {
    if (!text) throw new Error('No text');
    const { data } = await axios.post(`/messages`, { text, resource, resource_id, customer_id, trigger, message_type });
    return data;
  } catch (e) {
    throw e;
  }
}

const getUnreadCount = async () => {
  try {
    const { data } = await axios.get(`/messages/unread-count`);
    return data;
  } catch (e) {
    throw e;
  }
}

const markRead = async ({customer_id, message_id}) => {
  try {
    const { data } = await axios.post(`/messages/threads/${customer_id}/read`, { last_message_id: message_id });
    return data;
  } catch (e) {
    throw e;
  }
}

export { getMessages, sendMessage, getUnreadCount, markRead };